import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { SocketIoConfig } from 'ngx-socket-io';

interface SocketIoConfigWithTransportFallback extends SocketIoConfig {
  options: NonNullable<SocketIoConfig['options']> & {
    tryAllTransports: boolean;
  };
}

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  public urlApp: string = environment.urlApp;
  public urlBackEnd: string = environment.urlBackEnd;
  public urlBackEndApi: string = environment.urlBackEndApi;
  public recordServer: string = environment.recordServer;
  public socketConfig: SocketIoConfigWithTransportFallback = environment.socketConfig;
  public enableVideoCompression: boolean = environment.enableVideoCompression;

  // private primaryDomain = 'https://app.pyjam.com';
  private fallbackDomain = 'https://spb.pyjam.com';
  private fallbackMediaDomain = 'https://spb-media.pyjam.com';

  initializeConfig(): void {
    // ШАГ 1: Если мы УЖЕ на резервном домене, просто используем его.
    if ((typeof window !== 'undefined') && (window.location.origin === this.fallbackDomain)) {
      console.log(`Приложение уже запущено с домена ${this.fallbackDomain}. Принудительно используем его.`);
      this.setFallbackConfig();
    }

    // ШАГ 2: Иначе, запускаем старую логику проверки, если основной домен в конфиге.
    // else if (configService.urlApp === primaryDomain) {
    //   console.log(`Обнаружен домен ${primaryDomain}. Начинаем проверку...`);
    //   try {
    //     const controller = new AbortController();
    //     const timeoutId = setTimeout(() => controller.abort(), 10000);
    //     await fetch(primaryDomain, { signal: controller.signal, mode: 'no-cors' });
    //     clearTimeout(timeoutId);
    //     console.log('Основной домен доступен.');
    //   } catch (e) {
    //     console.warn('Основной домен недоступен. Переключаемся на spb.pyjam.com.');
    //     configService.urlApp = fallbackDomain;
    //     configService.urlBackEnd = fallbackDomain;
    //     configService.urlBackEndApi = `${fallbackDomain}/api`;
    //     configService.socketConfig = { url: fallbackDomain, options: { autoConnect: false } };
    //     configService.recordServer = fallbackMediaDomain;
    //   }
    // }
  }

  private setFallbackConfig(): void {
    this.urlApp = this.fallbackDomain;
    this.urlBackEnd = this.fallbackDomain;
    this.urlBackEndApi = `${this.fallbackDomain}/api`;
    this.socketConfig = {
      url: this.fallbackDomain,
      options: {autoConnect: false, transports: ['websocket', 'polling'], tryAllTransports: true},
    };
    this.recordServer = this.fallbackMediaDomain;
  }
}
